import { createRoutine } from 'redux-saga-routines';

export const showConnectModal = createRoutine('START_INTEGRATION');
export const showDisconnectModal = createRoutine('STOP_INTEGRATION');

export const connectIntegration = createRoutine('CONNECT_INTEGREATION');
export const udpateIntegreation = createRoutine('UPDATE_INTEGREATION');
export const disconnectIntegration = createRoutine('DISCONNECT_INTEGREATION');
export const requiredGrantErrorMessage = createRoutine(
  'REQUIRED_GRANT_ERROR_MESSAGE'
);
